const DataFilter = (thaiData,selectedYear,selectedMonth,selectedTimeFormat,selectedProvince,view, streamReady) => {

    let dataFilter = null;

    if(thaiData!=null){
        let dataSelect = {};
        if(streamReady){
            if(view === 1){ //for view 1 and view 2
                dataSelect = {
                    'view_1_month_province': thaiData[0].view_1_month_province,
                    'view_1_month_whole': thaiData[1].view_1_month_whole,
                    'view_1_month_both': thaiData[0].view_1_month_province.concat(thaiData[1].view_1_month_whole),
                    'view_1_week_province': thaiData[2].view_1_week_province,
                    'view_1_week_whole': thaiData[3].view_1_week_whole,
                    'view_1_week_both': thaiData[2].view_1_week_province.concat(thaiData[3].view_1_week_whole),
                    'view_1_year_province': thaiData[4].view_1_year_province,
                    'view_1_year_whole': thaiData[5].view_1_year_whole,
                    'view_1_year_both': thaiData[4].view_1_year_province.concat(thaiData[5].view_1_year_whole)
                };
            }
        } 

        let dataFilter;

        const countryFilter = (dataFilter) => {
            const dataByProvince = dataFilter.filter(function (data) {
                return data.value === 'ทั้งประเทศ';
            });
            return dataByProvince.length === 1;
        }

        const yearOnlyFilter = (dataFilter, year) => {
            const dataByYearOnly = dataFilter.filter(function (data) {
            return data.DYEAR === year || data.DYEAR === year+1;
            });
            return dataByYearOnly;
        }

        const yearFilter = (dataFilter, year, month) => {

            const dataByYear = dataFilter.filter(function (data) {       
                if (data.DYEAR === year && parseInt(data.DMON) >= month){
                    return true
                } else if (data.DYEAR === year+1){
                    return true
                } else if (month > 1 && data.DYEAR === year+2 && parseInt(data.DMON) <= month){
                    return true
                } else {
                    return false
                }
              });
            return dataByYear;
        }


        const provinceFilter = (dataFilter, province) => {
            let i = 0;
            const dataByProvince = dataFilter.filter(function (data) {
                for(i=0;i<province.length;i++){
                    if(data.PROVINCE.includes(province[i].value)){
                        return data; 
                    }
                }
              });
            return dataByProvince;
        }
        const filter_by_cond = (dataFilter) => {
            if( view === 1 ){
                if(selectedTimeFormat === 'เดือน' ){
                    // only province
                    if(!(countryFilter(selectedProvince)) && selectedProvince.length != 0){
                        dataFilter = yearFilter(dataSelect.view_1_month_province, selectedYear, selectedMonth);
                        dataFilter = provinceFilter(dataFilter, selectedProvince);
                        
                    // only whole
                    } else if(countryFilter(selectedProvince) && selectedProvince.length === 1){
                        dataFilter = yearFilter(dataSelect.view_1_month_whole, selectedYear, selectedMonth);

                    // nothing selected
                    } else if (selectedProvince.length === 0){
                        dataFilter = null;

                    // select both whole and province
                    } else {
                        let dataFilter_province = yearFilter(dataSelect.view_1_month_province, selectedYear, selectedMonth); 
                        let dataFilter_whole = yearFilter(dataSelect.view_1_month_whole, selectedYear, selectedMonth); 
                        dataFilter_province = provinceFilter(dataFilter_province, selectedProvince);
                        dataFilter = dataFilter_whole.concat(dataFilter_province);
                    }
                } else if(selectedTimeFormat === 'สัปดาห์' ){
                    // only province
                    if(!(countryFilter(selectedProvince)) && selectedProvince.length != 0){
                        dataFilter = yearFilter(dataSelect.view_1_week_province, selectedYear, selectedMonth);
                        dataFilter = provinceFilter(dataFilter, selectedProvince);
                        // only whole
                    } else if(countryFilter(selectedProvince) && selectedProvince.length === 1){
                        dataFilter = yearFilter(dataSelect.view_1_week_whole, selectedYear, selectedMonth);

                    // nothing selected
                    } else if (selectedProvince.length === 0){
                        dataFilter = null;

                    // select both whole and province
                    } else {
                        let dataFilter_province = yearFilter(dataSelect.view_1_week_province, selectedYear, selectedMonth); 
                        let dataFilter_whole = yearFilter(dataSelect.view_1_week_whole, selectedYear, selectedMonth); 
                        dataFilter_province = provinceFilter(dataFilter_province, selectedProvince);
                        dataFilter = dataFilter_whole.concat(dataFilter_province);
                    }
                } else if(selectedTimeFormat === 'ปี' ){
                    // only province
                    if(!(countryFilter(selectedProvince)) && selectedProvince.length != 0){
                        dataFilter = provinceFilter(dataSelect.view_1_year_province, selectedProvince);
                        
                    // only whole
                    } else if(countryFilter(selectedProvince) && selectedProvince.length === 1){
                        dataFilter = dataSelect.view_1_year_whole;
                    // nothing selected
                    } else if (selectedProvince.length === 0){
                        dataFilter = null;
                    // select both whole and province
                    } else {
                        let dataFilter_province = provinceFilter(dataSelect.view_1_year_province, selectedProvince); 
                        let dataFilter_whole = dataSelect.view_1_year_whole;
                        dataFilter = dataFilter_whole.concat(dataFilter_province);
                    }
                }
            } 
        
            return {dataFilter};
        }

        dataFilter = filter_by_cond(dataFilter);
        if(dataFilter.dataFilter != undefined){
            if(dataFilter.dataFilter.length != 0){
                let dataFilterTemp = [...dataFilter.dataFilter ];
                dataFilterTemp = dataFilterTemp.sort((a, b) => a.engDate - b.engDate);
                dataFilter.dataFilter = dataFilterTemp.sort(function (a, b) {
                    if (a.PROVINCE){
                        return  b.PROVINCE ? a.PROVINCE.localeCompare(b.PROVINCE) : -1;
                    }            
               });
            }
        }

        return dataFilter;
    
    }

    return {dataFilter};
}
 
export default DataFilter;